export default [
  {
    path: '/manage-countries',
    component: () => import('@/admin/pages/ManageCountries'),
    name: 'ManageCountries',
  }
]
